module.exports = __webpack_public_path__ + "static/media/dcr.858b5ebf.svg";